import React from 'react';


export class Label extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.generateState()
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props !== prevProps) {
            this.setState(this.generateState());
        }
    }

    generateState = () => {
        return {
            text: '',
            color: 'main',
            textColor: 'white',
            icon: null,
            size: null,
            onCancel: null,
            class: '',
            ...this.props
        };
    }

    render() {
        return (
            <span className={'imd-label imd-bg-' + this.state.color + ' imd-text-' + this.state.textColor + ' ' + this.state.class}>
                {
                    this.state.icon !== null ?
                        <span className={this.state.icon} style={{display: 'inline-block', marginRight: '3px'}} /> :
                        null
                }
                {this.state.text}
                {
                    this.state.onCancel !== null ?
                        <span className="imd-icon imd-icon-xmark" onClick={() => this.state.onCancel()} style={{display: 'inline-block', marginBottom: '-2px'}} /> :
                        null
                }
            </span>
        );
    }
}
